import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import Header from '../../components/Header/Header';
import Picker from '../../components/Picker/Picker';
import ConfigurationLogsModal from './ConfigurationLogsModal';
import './style.scss';

import _ from 'lodash';

import PopupAlert from '../../components/Notifications/PopupAlert';

import G5DevicesTabsView from './G5DevicesTabsView';

import * as devicesActions from '../../actions/DeviceConfigurationAction';
import * as actionsFiles from '../../actions/FilesActions';
import * as actionsProjects from '../../actions/ProjectsActions';
import * as actionsSearch from '../../actions/SearchActions';
import { downloadFileFromURl } from '../../actions/selectors';

import ExcelJS from 'exceljs';

import { getDateForExcelExports } from '../../actions/Utilities/dateUtils';
import {
  buildG5ConfigItems,
  G5_CONFIG_EXPORT_COLUMNS,
  getG5ConfigExportValue,
} from './TabsTables/g5ConfigColumns';

import * as actionsDevices from '../../actions/DeviceConfigurationAction';
import { doSignOut } from '../../actions/LoginActions';
import * as actionsSensors from '../../actions/SensorsActions';

import AssamblyLayout from './TabsTables/AssamblyLayout';
import CommandsLayout from './TabsTables/CommandsLayout';
import ConfigsTable from './TabsTables/ConfigsTable';
import StatusesTable from './TabsTables/StatusesTable';
import { getUIinfo } from '../../containers/UIhelper/UIhelper';

function createXlsDataFormate(
  title,
  value,
  numFormat,
  titleWidthType,
  titleWidthValue
) {
  return {
    title,
    titleWidthType,
    titleWidthValue,
    value,
    numFormat,
  };
}

class MainPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'status',
      popupAlert: {
        popupKey: -1,
        message: '',
        severity: 'info',
        action: '',
        logsModalOpen: false,
      },
      xlsDevicesData: null,
      selectedProjectItem: null,
      uiInfo: getUIinfo({ minWidth: 1400 }),
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateUIinfo);
    this.props.fetchDevices();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateUIinfo);
  }

  componentWillReceiveProps(nextProps) {
    const { projectsList, selectedProject, fetchDevices } = nextProps;

    if (
      selectedProject !== this.props.selectedProject ||
      this.props.selectedProject == null
    ) {
      const { selectedProject } = nextProps;
      fetchDevices();
      browserHistory.push({
        pathname: this.props.location.pathname,
        query: { project: selectedProject },
      });

      const prj =
        projectsList.items[projectsList.projectIndexMap[selectedProject]];
      this.setState({
        selectedProjectItem: prj,
      });
    }

    if (!_.isEqual(this.props.deviceList, nextProps.deviceList)) {
      const devicesDataSet = this.setDevicesData(nextProps.deviceList);
      this.setState({
        xlsDevicesData: devicesDataSet,
      });
    }

    if (!_.isEqual(this.props.devicesForDisplay, nextProps.devicesForDisplay)) {
      const devicesDataSet = this.setDevicesData(nextProps.devicesForDisplay);
      this.setState({
        xlsDevicesData: devicesDataSet,
      });
    }
  }

  updateUIinfo = () => {
    this.setState({
      uiInfo: getUIinfo({ minWidth: 1400 }),
    });
  };

  setDevicesData = (devices) => {
    const configItems = buildG5ConfigItems(devices, this.props.options);
    const columns = G5_CONFIG_EXPORT_COLUMNS.map((column) =>
      this.setDeviceDataTitle(column.title, 'wch', Math.max(column.width / 8, 12))
    );

    const xlsData = [
      {
        columns: columns,
        data: configItems.map((device) =>
          G5_CONFIG_EXPORT_COLUMNS.map((column) => ({
            value: getG5ConfigExportValue(column, device),
            style: { font: { sz: '12' } },
          }))
        ),
      },
    ];

    return xlsData;
  };

  setDeviceDataTitle = (title, widthType, widthValue) => ({
    title,
    width: { [widthType || 'wch']: widthValue || title.length + 2 },
    style: { alignment: { horizontal: 'center', vertical: 'center' } },
  });

  onPathChange = () => {};

  handleDownloadFile = (filePath, usingType) => {
    const { dispatch, selectedProject } = this.props;
    if (usingType !== 'upload') {
      this.notify(
        this.context.t(
          'preparing_to_download_if_download_does_not_commence_please_allow_popups_for_this_site'
        ),
        'info'
      );
    }
    dispatch(
      actionsFiles.getUrlForDownloadFile(
        selectedProject,
        filePath,
        usingType,
        '0',
        (res) => {
          if (!res.status) {
            this.notify(this.context.t('download_failed_file_not_found'), 'error');
          } else {
            downloadFileFromURl(res.data);
          }
        }
      )
    );
  };

  notify = (message, level, action) => {
    this.setState({
      popupAlert: {
        popupKey: new Date().getTime(),
        message: message,
        severity: level,
        action: action,
      },
    });
  };

  signOutFunction = () => {
    this.props.dispatch(doSignOut());
  };

  // ***** Minimal change: New ExcelJS export function *****
  handleExportExcel = async () => {
    if (!this.state.xlsDevicesData) {
      this.notify('No data available for export', 'info');
      return;
    }
    const { projectsList, selectedProject } = this.props;
    const selectedProjectIndex = projectsList.projectIndexMap[selectedProject];
    const selectedProjectName =
      projectsList.items[selectedProjectIndex]?.ShortName;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Devices');

    const dataSet = this.state.xlsDevicesData[0];
    worksheet.columns = dataSet.columns.map((col) => ({
      header: col.title,
      key: col.title,
      width: col.width.wch || col.width.wpx || col.title.length + 2,
    }));

    dataSet.data.forEach((row) => {
      const rowValues = row.map((cell) => cell.value);
      worksheet.addRow(rowValues);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    const projectPrefix = selectedProjectName ? `${selectedProjectName}_` : '';
    const filename = `${projectPrefix}${getDateForExcelExports()}_G5_Devices.xlsx`;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };


  render() {
    const {
      user,
      selectedProject,
      timeZone,
      deviceList,
      sort,
      devicesForDisplay,
      bitsInfo,
      selection,
      projectsList,
      fwVersions,
      fwUltraVersions,
      fwUltraModemVersions,
      fwModemVersions,
    } = this.props;

    const tabs = [
      {
        label: this.context.t('status'),
        style: { maxHeight: 'inherit', margin: 'auto', width: 'fit-content' },
        component: (
          <StatusesTable
            items={devicesForDisplay}
            sort={sort}
            selectedItems={this.props.selection}
            workingMode={this.state.mode}
            handleSelection={this.props.selectDevice}
            reloadDevices={this.props.fetchDevices}
            local={timeZone}
            options={this.props.options}
            uiInfo={this.state.uiInfo}
          />
        ),
      },
      {
        label: this.context.t('configuration'),
        style: { maxHeight: 'inherit', margin: 'auto', width: 'fit-content' },
        component: (
          <ConfigsTable
            items={devicesForDisplay}
            sort={sort}
            selectedItems={this.props.selection}
            workingMode={this.state.mode}
            handleSelection={this.props.selectDevice}
            reloadDevices={this.props.fetchDevices}
            local={timeZone}
            options={this.props.options}
            uiInfo={this.state.uiInfo}
          />
        ),
      },
    ];

    if (JSON.parse(process.env.REACT_APP_SHOW_G5_ASSEMBLY || false)) {
      tabs.push({
        label: this.context.t('assembly'),
        style: { maxHeight: 'inherit', margin: 'auto', width: 'fit-content' },
        component: (
          <AssamblyLayout
            bitsInfo={deviceList}
            timeZone={timeZone}
            selectMultipleDevices={this.props.selectMultipleDevices}
            updateConfig={this.props.updateConfig}
            reloadDevices={this.props.fetchDevices}
            notify={this.notify}
            selectedItems={this.props.selection}
          />
        ),
      });
    }

    if (JSON.parse(process.env.REACT_APP_SHOW_G5_COMMANDS || false)) {
      tabs.push({
        label: this.context.t('commands'),
        style: {
          maxHeight: 'inherit',
          width: 'fit-content',
          height: '84vh',
          overflowY: 'auto',
        },
        component: (
          <CommandsLayout
            getDefault={this.props.fetchProjectDefaultConfiguration}
            updateConfig={this.props.updateConfig}
            updateDefaultConfig={this.props.updateDefaultConfig}
            notify={this.notify}
            selectedItems={this.props.selection}
            sendActionCommand={this.props.sendActionCommand}
            timeZone={this.props.timeZone}
            enable={selection.length > 0}
            fwVersions={fwVersions}
            fwUltraVersions={fwUltraVersions}
            fwUltraModemVersions={fwUltraModemVersions}
            fwModemVersions={fwModemVersions}
            fm2ConfigOptions={this.props.options.FM2ConfigType}
            user={user}
            selectedProject={selectedProject}
          />
        ),
      });
    }

    return (
      <main>
        <div style={{ position: 'absolute', top: '90px', right: '0px' }}>
          <Picker
            value={selectedProject}
            onChange={this.props.handleProjectChange}
            options={projectsList.items}
            isAqsAdmin={user.isAQS}
          />
        </div>

        <Header
          selectedProject={selectedProject}
          onPathChange={this.onPathChange}
          user={user}
          local={timeZone}
          downloadFile={this.handleDownloadFile}
          logo={user.logo}
          signOutFunc={this.signOutFunction}
          lang={this.props.lang}
          appContext='portal'
        />

        <G5DevicesTabsView
          tabs={tabs}
          selectedProject={selectedProject}
          timeZone={timeZone}
          deviceList={deviceList}
          sort={sort}
          devicesForDisplay={devicesForDisplay}
          selection={selection}
          handleProjectChange={this.props.handleProjectChange}
          handleDownloadFile={this.handleDownloadFile}
          handleExportExcel={this.handleExportExcel}
          user={user}
          options={this.props.options}
          fetchDevices={this.props.fetchDevices}
          fetchProjectDefaultConfiguration={this.props.fetchProjectDefaultConfiguration}
          updateConfig={this.props.updateConfig}
          updateDefaultConfig={this.props.updateDefaultConfig}
          sendActionCommand={this.props.sendActionCommand}
          selectedProjectItem={this.state.selectedProjectItem}
          projectsList={projectsList}
          messagesLogs={this.props.messagesLogs}
          hideHeader={this.props.hideHeader}
        />

        {user.isAQS && (
          <ConfigurationLogsModal
            open={this.state.logsModalOpen}
            closeLogsModal={() => this.setState({ logsModalOpen: false })}
            data={this.props.messagesLogs}
            timeZone={this.props.timeZone}
          />
        )}

        {this.state.popupAlert && <PopupAlert {...this.state.popupAlert} />}
      </main>
    );
  }
}

MainPage.propTypes = {
  deviceList: PropTypes.array.isRequired,
  fetchDevices: PropTypes.func.isRequired,
  fetchProjectDefaultConfiguration: PropTypes.func.isRequired,
  fwVersions: PropTypes.arrayOf(PropTypes.string).isRequired,
  fwUltraVersions: PropTypes.arrayOf(PropTypes.string).isRequired,
  fwUltraModemVersions: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleProjectChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  projectsList: PropTypes.object.isRequired,
  selectDevice: PropTypes.func.isRequired,
  selectMultipleDevices: PropTypes.func,
  selectedProject: PropTypes.string.isRequired,
  selection: PropTypes.array.isRequired,
  sendActionCommand: PropTypes.func,
  timeZone: PropTypes.string.isRequired,
  updateConfig: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  messagesLogs: PropTypes.array,
  hideHeader: PropTypes.bool,
};

MainPage.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
  const { user, projectsList, selectedProject, optionList } = state.leaksList;
  const timeZone = state.local.timeZone;
  const lang = state.i18nState.lang || 'en';
  const {
    deviceList,
    devicesForDisplay,
    sort,
    bitsInfo,
    selection,
    fwVersions,
    fwUltraVersions,
    fwUltraModemVersions,
    fwModemVersions,
    messagesLogs,
  } = state.devcieConfigurations;
  const { options } = optionList;

  return {
    ...props,
    timeZone,
    lang,
    user: user,
    deviceList,
    devicesForDisplay,
    sort,
    bitsInfo,
    selection,
    projectsList,
    selectedProject,
    options,
    fwVersions,
    fwUltraVersions,
    fwUltraModemVersions,
    fwModemVersions,
    messagesLogs,
  };
};

function mapDispatchToProps(dispatch, props) {
  return {
    fetchProjectDefaultConfiguration: function () {
      return new Promise((resolve, reject) => {
        dispatch(actionsDevices.fetchProjectDefaultConfiguration()).then(
          (json) => {
            resolve(json);
          }
        );
      });
    },
    fetchDevices: function () {
      dispatch(actionsDevices.fetchDevices());
      dispatch(actionsDevices.fetchFwVersions());
      dispatch(actionsDevices.fetchFwUltraVersions());
      dispatch(actionsDevices.fetchFwUltraModemVersions());
      dispatch(actionsDevices.fetchFwModemVersions());
      // dispatch(actionsSensors.fetchG5SensorsStatuses());
      dispatch(actionsSensors.fetchG5BitInfo());
    },
    selectDevice: function (selection, mode) {
      dispatch(actionsDevices.selectDevices(selection));
    },
    selectMultipleDevices: function (devices) {
      dispatch(actionsDevices.selectDevices(devices));
    },
    updateConfig: function (values, type, notifyFunc) {
      dispatch(devicesActions.setDeviceConfiguration(type, values))
        .then((data) => {
          if (data.err) {
            notifyFunc(JSON.stringify(data.err), 'error');
          } else {
            notifyFunc(`${type} message was sent successfully`, 'success');
          }
        })
        .catch((err) => {
          notifyFunc(JSON.stringify(err), 'error');
        });
    },
    updateDefaultConfig: function (values, type, notifyFunc) {
      dispatch(devicesActions.setProjectDefaultConfiguration(type, values))
        .then((data) => {
          if (data.err) {
            notifyFunc(JSON.stringify(data.err), 'error');
          } else {
            notifyFunc(`${type} defaults was set successfully`, 'success');
          }
        })
        .catch((err) => {
          notifyFunc(JSON.stringify(err), 'error');
        });
    },
    sendActionCommand: function (action) {
      dispatch(actionsDevices.setActionCommand(action));
    },
    handleProjectChange: function (nextProject) {
      dispatch(actionsProjects.selectProjectAction(nextProject));
    },
    searchDevice: function (value, type) {
      return new Promise((resolve, reject) => {
        dispatch(
          actionsSearch.searchItem(
            value,
            type,
            'g5Devices',
            (featureIndex, serverResult) => {
              if (featureIndex != null) {
                resolve();
              } else {
                if (serverResult == null || serverResult.status == false) {
                  reject(new Error('search failed. result: ' + serverResult));
                } else {
                  resolve(serverResult);
                }
              }
            }
          )
        );
      });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
